import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomNativeDateAdapter extends NativeDateAdapter {
  /**
   * Change dates in calendar from narrow to short ones.
   * Fr -> Fri
   * @param style
   */
  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    if (style === 'narrow') {
      return super.getDayOfWeekNames('short');
    }
    return super.getDayOfWeekNames(style);
  }
}

export const APP_DATE_FORMATS = {
  parse: {
    dateInput: 'yyyy-MM-dd',
  },
  display: {
    monthLabel: 'MMMM',
    dateInput: 'yyyy-MM-dd',
    monthYearLabel: 'yyyy MMMM',
    dateA11yLabel: 'MMMM d yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};
